module.exports = __webpack_public_path__ + "static/media/bausch.d71963b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/client_logos/bausch.png
// module id = 262
// module chunks = 0